module.exports = __webpack_public_path__ + "img/estacionamento-info-icon.469a06a2.svg";